import { Box, ButtonBase, Tooltip } from "@mui/material";
import Check from "@mui/icons-material/Check";
import { projectColors, projectColorText } from "../../misc/projectColors";

export function ProjectColorPicker(props: {
    value: string;
    onChange: (value: string) => void;
}) {
    return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {projectColors().map(color => (
                <Tooltip key={color.key} title={color.label}>
                    <ButtonBase
                        aria-label={color.label}
                        onClick={() => props.onChange(color.key)}
                        sx={{
                            width: 22,
                            height: 22,
                            borderRadius: "50%",
                            bgcolor: color.bg,
                            border: 2,
                            borderColor: props.value === color.key ? color.border : "transparent",
                            color: projectColorText(),
                            "&:hover": { bgcolor: color.hover },
                        }}
                    >
                        {props.value === color.key && <Check sx={{ fontSize: 14 }} />}
                    </ButtonBase>
                </Tooltip>
            ))}
        </Box>
    );
}
